import React from "react"
import styled from "@emotion/styled"
import TopBannerHomepage from "components/Homepage/topBannerHomepage"

const HomepageWrapper = styled.div`
    position: relative;
    overflow: hidden;
    color: ${(props) => props.theme.colors.background};
    & h3 {
        margin-bottom: 0;
        font-weight: 400;
    }
    & h1 {
        margin-top: 0;
    }
`

const PurpleBox = styled.div`
    position: absolute;
    background-color: #3bacd2;
    left: 15%;
    z-index: 10;
    color: ${(props) => props.theme.colors.background};
    bottom: 3rem;
    width: 75%;
    height: auto;
    padding-left: 1rem;
    text-align: center;
    border-radius: 2rem;

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        bottom: 2rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        bottom: 1.7rem;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[8]}) {
        width: 80%;
        left: 10%;
    }

    & p {
        color: ${(props) => props.theme.colors.background} !important;
        font-size: 35px;
        font-family: Museo Slab;
        margin: 1rem;
        font-weight: 500;

        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[8]}) {
            line-height: 1.2;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[7]}) {
            font-size: 30px;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[6]}) {
            line-height: 1;
            font-size: 25px;
        }

        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[4]}) {
            font-size: 22px;
            margin: 0.4rem;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[3]}) {
            line-height: 1.2;
            font-size: 16px;
            margin: 0.4rem;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[2]}) {
            font-size: 10px;
            margin: 0.2rem;
        }
        @media screen and (max-width: ${(props) =>
                props.theme.breakpoints[1]}) {
            margin: 0.1rem;
        }
    }
`

const WhiteCurve = styled.div`
    width: 102%;
    height: 5rem;
    border-radius: 50%/100px 100px 0 0;
    background-color: ${(props) => props.theme.colors.background};
    left: -1%;
    bottom: 0;
    position: absolute;

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        height: 3rem;
        border-radius: 50%/100px 75px 0 0;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        height: 2rem;
        border-radius: 50%/100px 50px 0 0;
    }
`

function HomepageBanner({ data }) {
    return (
        <HomepageWrapper>
            <TopBannerHomepage data={data} />
            <PurpleBox>
                <div dangerouslySetInnerHTML={{ __html: data.description }} />
            </PurpleBox>
            <WhiteCurve />
        </HomepageWrapper>
    )
}

export default HomepageBanner
